import Vue from 'vue';
import {
    MainVueOpts
} from '../../main-vue';
import Vuelidate from 'vuelidate';
import VueResource from 'vue-resource';

let moment = require('moment');

const {
    required,
} = require('vuelidate/lib/validators');

import {
    noForeignCharacters,
    goToFirstError,
    ApiUrls,
    SessionKeys,
    setItemSessionStorage,
    getItemSessionStorage,
    deleteSessionStore,
    scrollToBlock,
    singleDateValidation,
    dateNotInFutureSingleDate
} from '../../helper-functions';

import Spinner from '../../components/components.spinner.vue';
import Snackbar from "../../components/components.snack-bar.vue";
import Modal from '../../components/components.model.vue';
import InlineAds from '../../components/components.inline-ads.vue';
import DatePicker from '../../components/components.date-picker.vue';
import '../../filters/filters.date-time';

Vue.use(Vuelidate);
Vue.use(VueResource);

const Pregnancyform = {
  lastMentural: "",
  estimatedDueDate: "",
  estimateWeeks: "",
  weeksPregnant: null
};

Vue.component('pregnancy-calculator', {
    components: {
        InlineAds,
        'date-picker': DatePicker
    },
    data () {
        return {
            form: { ...Pregnancyform },
            isFormSubmitted: {
                forward: false,
                backward: false,
                daysToWeeks: false,
                weeksToDays: false
            },
            isLoading: false,
            errors: [],
            pregnancyResult: {},
            dateRangePicker: {
                dateFormat: 'MM-DD-YYYY',
                singleDatePicker: true,
                autoApply: true,
                defaultRange: '',
            },
            calcYet: 0,
            theDate: {
                eddDate: null,
                dueDate: null
            },
            firstTrimester: "",
            conceptionOccured: "",
            secondTrimester: "",
            errorCalcEstWeeks: {
                lessThan: false,
                lmpEstFirst: false
            },
            errorCalcWeeksToDays: {
                numb: false,
                lmpEstFirst: false,
                errorMessage: ""
            },
            targetedAds: window.immiObj.targetedAds
        }
    },
    created () {

    },
    validations () {
        let validations = {
            form: {
                lastMentural: {
                    required,
                    singleDateValidation
                },
                estimatedDueDate: {
                    required,
                    singleDateValidation
                },
                estimateWeeks: {
                    required,
                    singleDateValidation
                },
                weeksPregnant: {
                    required                    
                }
            }
        };

        return validations;
    },
    watch: {
        calcYet (val) {
            if(val) {
                this.errorCalcEstWeeks.lmpEstFirst = false;
                this.errorCalcEstWeeks.lessThan = false;
                this.errorCalcWeeksToDays.lmpEstFirst = false;
                this.errorCalcWeeksToDays.numb = false;
            }
        },
        'form.estimateWeeks' (val) {
            this.errorCalcEstWeeks.lessThan = false;            
        },
        'form.weeksPregnant' (val) {
            this.errorCalcWeeksToDays.errorMessage = "";
            this.errorCalcWeeksToDays.numb = false;
        }
    },
    methods: {
        reset () {
            this.$v.form.$reset();
            this.form = { ...Pregnancyform };
        },
        calculateForward () {            
            this.isFormSubmitted.forward = true;
            this.setFromSubmitFalse('calcForward');
            this.$v.form.lastMentural.$touch();
            
            if (!this.$v.form.lastMentural.$invalid) {
                this.calcYet = 1;
                const lmp = new Date(this.form.lastMentural + " 12:00:00");
                this.theDate.dueDate = lmp.getTime();

                let concep = 14; // conception occurs at 2 weeks (14 days)
                let first = 84; // end of first trimester at 12 weeks
                let second = 189; // end of second trimester
                let edd = 280;

                this.conceptionOccured = this.display(lmp.getTime(), concep, 0, 0);
                this.firstTrimester = this.display(lmp.getTime(), first, 0, 0);
                this.secondTrimester = this.display(lmp.getTime(), second, 0, 0);
                
                this.display(lmp.getTime(), edd, 1, 0);
            }
        },
        display(whatDate, numDays, isEdd, isLMP) {
            let today = new Date();
            let lmp = new Date(whatDate);
            
            //  convert lmp to milliseconds, and add appropriate msec
            let futureDate = lmp.getTime() + (numDays * 24*60*60*1000);

            let future = new Date();
            future.setTime(futureDate);
            future.setHours(12);
            let futureYear = future.getYear();

            let yearChoice = null;

            if(isEdd == 1) {
                yearChoice = 0;            
            
                if ((lmp.getYear() == today.getYear()) && (today.getYear() != futureYear)) {
                    yearChoice = 1;
                }

                if (futureYear < today.getYear()) {
                    yearChoice = -1;
                }

                this.form.estimatedDueDate = moment(future).format("MM/DD/YYYY");
                this.theDate.eddDate = future.getTime();
            }

            if(isLMP === 1) {
                yearChoice = 1;

                //  Do we need to change the displayed LMP year?

                if ((lmp.getYear() == today.getYear()) && (today.getYear() != futureYear)) {
                    yearChoice = 0;
                }

                if (today.getYear() < futureYear) {
                    yearChoice = -1;
                }

                this.form.lastMentural = moment(future).format("MM/DD/YYYY");
                this.theDate.dueDate = future.getTime();

            }

            //  Calculate # weeks pregnant, based on today's date
            if ((isEdd == 1) || (isLMP == 1)) {
                // First, reset all values in the purple box
                let esitWeek = moment(today).format("MM/DD/YYYY");
                let lastMenCycl = new Date(this.form.lastMentural).getTime();
                let tDate = new Date().getTime();
                let isPastFourty = false;
                if (tDate < lastMenCycl) {
                    esitWeek = moment(new Date(this.form.lastMentural)).add(1, 'M').format("MM/DD/YYYY");
                } else if (tDate > lastMenCycl) {
                    let addFourty = moment(new Date(this.form.lastMentural)).add(40, 'W').format("MM/DD/YYYY");
                    addFourty = new Date(addFourty).getTime();
                    if (tDate > addFourty) {
                        esitWeek = moment(new Date(this.form.lastMentural)).add(1, 'M').format("MM/DD/YYYY");
                        isPastFourty = true;
                    }
                }
                this.form.estimateWeeks = esitWeek;
                this.form.weeksPregnant = "";
                today.setHours(13);
                /* Since LMP is set to 12:00 noon, we must set
                today's time temporarily to 1:00 pm, so that
                if today date = LMP date, then 
                today's time is GREATER than LMP time
                */
               var todaydate = today.getTime();
               var lmpdate = +this.theDate.dueDate;
               var edd = +this.theDate.eddDate;
               edd = Number(edd) + 10 * 7 * 24 * 60 * 60 * 1000;
               //  Allow for up to 50 weeks EGA

               if ((todaydate > lmpdate) &&
                   (todaydate < edd)) {
                   // Check that today's date is BETWEEN 
                   // the LMP and EDD
                   if (tDate < lastMenCycl) {
                       todaydate = new Date(esitWeek).getTime();
                   }
                   this.form.weeksPregnant = this.calcEGA(lmpdate, todaydate);
               } else {
                   if (tDate < lastMenCycl || isPastFourty) {
                       todaydate = new Date(esitWeek).getTime();
                       this.form.weeksPregnant = this.calcEGA(lmpdate, todaydate);
                   }
               }

               return true;
            }

            //  Year-2000 compliance test
            if (futureYear < 300) {
                futureYear = futureYear + 1900
            }

            var futureDisplay = moment(future).format("dddd, MMMM DD, YYYY");

            return futureDisplay;
        },
        calcEGA (lmpDate, desDate) {
            var daysEGA = (desDate - lmpDate) / (1000 * 60 * 60 * 24);
            var EGA = Math.floor(daysEGA / 7);
            var EGAfrac = Math.round(daysEGA % 7);
            //  Daylight Savings Time (DST) makes this calculation
            //  veer slightly off from being integer.

            if (EGAfrac == 7) { //  Another correction for DST
                EGAfrac = 0;
                EGA = EGA + 1;
            }

            if (EGAfrac == 0) {
                return EGA
            }

            EGA = EGA + " " + EGAfrac + "/7";
            return EGA
        },
        calculateBackward () {
            this.isFormSubmitted.backward = true;
            this.setFromSubmitFalse('calcBackward');
            this.$v.form.estimatedDueDate.$touch();
            let eddYear = new Date(this.form.estimatedDueDate).getFullYear();

            if (!this.$v.form.estimatedDueDate.$invalid) {
                this.calcYet = 1;
                let today = new Date();
                let thisYear = today.getFullYear();
                eddYear = thisYear + 1; // Next Year

                let edd = new Date(this.form.estimatedDueDate + " 12:00:00");
                this.theDate.eddDate = edd.getTime();

                let lmp = -280; // estimated due date
                let concep = -266; // conception occurs at 2 weeks (14 days)
                let first = -196; // end of first trimester at 12 weeks
                let second = -91; // end of second trimester

                //  The last "1" indicates this is LMP
                this.display(edd.getTime(), lmp, 0, 1);

                this.conceptionOccured = this.display(edd.getTime(), concep, 0, 0);
                this.firstTrimester = this.display(edd.getTime(), first, 0, 0);
                this.secondTrimester = this.display(edd.getTime(), second, 0, 0);

                // return true;
            }
        },
        calculateDaysToWeeks () {
            this.isFormSubmitted.daysToWeeks = true;
            this.$v.form.estimateWeeks.$touch();            
            this.errorCalcEstWeeks.lessThan = false;
            this.setFromSubmitFalse('daysToWeek');

            if(!this.$v.form.estimateWeeks.$invalid && this.calcYet) {
                this.errorCalcEstWeeks.lmpEstFirst = false;
                let today = new Date();
                let thisYear = today.getFullYear();
                let desiredYear = thisYear + desiredYear - 1;
                let des = new Date(this.form.estimateWeeks + " 14:00:00");
                let lmpDate = this.theDate.dueDate;
                let eddDate = this.theDate.eddDate;
                eddDate = Number(eddDate) + 10 * 7 * 24 * 60 * 60 * 1000;
                // Allow EDD to be 50 weeks for maximum
                let desDate = des.getTime();

                if ((desDate < lmpDate) || (desDate > eddDate)) {
                    // Error: Select a date between the Last Menstrual Period and the Estimated Due Date.
                    this.errorCalcEstWeeks.lessThan = true;
                } else {
                    this.form.weeksPregnant = this.calcEGA(lmpDate, desDate);
                }
            } else {
                this.errorCalcEstWeeks.lmpEstFirst = true;
            }
        },
        calculateWeeksToDate () {
            this.isFormSubmitted.weeksToDays = true;
            this.$v.form.weeksPregnant.$touch();
            this.errorCalcWeeksToDays.errorMessage = "";
            this.setFromSubmitFalse('weeksToDate');

            if(!this.$v.form.weeksPregnant.$invalid && this.calcYet) {
                this.errorCalcWeeksToDays.lmpEstFirst = false;
                let add = this.form.weeksPregnant || '';
                if(add && typeof add == 'string' && add.indexOf("/") != -1) {
                    add = this.evalFrac(add);
                    if(add === false) {
                        return false;
                    }
                }

                if ((add == "") || (isNaN(add)) || (add < 0) || (add > 50)) {
                    this.errorCalcWeeksToDays.errorMessage = "Please enter a valid number of weeks.";
                    return false;
                }

                //  Adding milliseconds
                let lmpDate = +this.theDate.dueDate;
                let egaMsec = lmpDate + (add * 7 * 24 * 60 * 60 * 1000);

                let today = new Date();
                let todayYr = today.getFullYear();

                //  Convert the EGA to a date
                let ega = new Date();
                ega.setTime(egaMsec);
                let egaYr = ega.getFullYear();                

                let egaYear = (egaYr - todayYr) + 1;
                this.form.estimateWeeks = moment(ega).format("MM/DD/YYYY");

            } else {
                this.errorCalcWeeksToDays.lmpEstFirst = true;
            }
        },
        evalFrac(frac) {
            let slash = frac.indexOf("/");
            let isValid = false;
            if (frac.charAt(slash + 1) != 7) { // Is denominator 7?                
                this.errorCalcWeeksToDays.errorMessage = "Weeks are expressed in fractions of 7.";
            } else if ((Number(frac.charAt(slash - 1)) > 6) ||
                //  Check numerator
                //isNaN(chaz) || frac.chuckhu(swish)
                (isNaN(frac.charAt(slash - 1)))) {
                this.errorCalcWeeksToDays.errorMessage = "Please enter a proper fraction.";
            } else if ((frac.charAt(slash - 2) != " ") && (frac.indexOf("/") != 1)) {
                this.errorCalcWeeksToDays.errorMessage = "Please enter a proper fraction.";
            } else {
                //  Evaluate the fraction
                let top = Number(frac.charAt(slash - 1));
                let fraction = top / 7;
    
                //  Anything before the fraction?
                if (frac.indexOf("/") == 1) {
                    if (fraction == 0) {
                        fraction = 0.001
                        //  Prevents script from interpreting
                        //  this as a 'false' value
                    }
                    return fraction
                }
    
                let fullNum = frac.substring(0, frac.indexOf(" "));
                if (isNaN(fullNum)) {
                    this.errorCalcWeeksToDays.errorMessage = "Please enter a proper number of weeks.";                    
                } else {
                    isValid = true;
                }
    
                frac = Number(fullNum) + fraction;
                if (frac == 0) {
                    frac = 0.001
                }                
            }

            return isValid ? frac : false;
        },
        setFromSubmitFalse (type)  {
            switch (type) {
                case "weeksToDate":
                    this.isFormSubmitted.daysToWeeks = false;
                    this.isFormSubmitted.backward = false;
                    this.isFormSubmitted.forward = false;
                    break;
                case "calcBackward":
                    this.isFormSubmitted.weeksToDays = false;
                    this.isFormSubmitted.daysToWeeks = false;
                    this.isFormSubmitted.forward = false;

                    break;
                case "calcForward":
                    this.isFormSubmitted.weeksToDays = false;
                    this.isFormSubmitted.daysToWeeks = false;
                    this.isFormSubmitted.backward = false;
                    break;
                case "daysToWeek":
                    this.isFormSubmitted.weeksToDays = false;
                    this.isFormSubmitted.backward = false;
                    this.isFormSubmitted.forward = false;
                    break;                
            }
        }
    }
})